import { render, staticRenderFns } from "./DocumentApi.vue?vue&type=template&id=9fba4c76&"
import script from "./DocumentApi.vue?vue&type=script&lang=ts&"
export * from "./DocumentApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports